import React, { useState } from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import PharmaPartners from '../components/PharmaPartners';
import TopProducts from '../components/TopProducts';
import HowToOrder from '../components/HowToOrder';
import Testimonials from '../components/Testimonials';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Header from '../components/Header';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <About />
      <PharmaPartners />
      <TopProducts />
      <HowToOrder />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
